// src/components/PlatformProtectedRoute.js
//
// ProtectedRoute.js's own Super Admin panel equivalent — same shape, reads
// PlatformAuthContext instead of AuthContext, and redirects an unauthenticated
// visitor to "/platform-login" (never "/login" — that's a different app,
// reachable on a different host, with a different session entirely) and a
// permission-denied one to "/platform/denied".
import { useContext, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { PlatformAuthContext } from "../context/PlatformAuthContext";

export default function PlatformProtectedRoute({ children, requiredPermission }) {
  const { token, permissions, loading, setRedirectAfterLogin } =
    useContext(PlatformAuthContext);
  const location = useLocation();
  const [shouldRedirect, setShouldRedirect] = useState(false);

  useEffect(() => {
    if (!token) {
      setRedirectAfterLogin(location.pathname);
      setShouldRedirect(true);
    }
  }, [token, location.pathname, setRedirectAfterLogin]);

  if (loading) {
    return (
      <div style={{ textAlign: "center", marginTop: 50 }}>
        Loading permissions...
      </div>
    );
  }

  if (shouldRedirect) {
    return <Navigate to="/platform-login" replace />;
  }

  if (token && (!permissions || permissions.length === 0)) {
    return (
      <div style={{ textAlign: "center", marginTop: 50 }}>
        Checking access...
      </div>
    );
  }

  if (requiredPermission && !permissions.includes(requiredPermission)) {
    return <Navigate to="/platform/denied" replace />;
  }

  return children;
}
